// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 8px;
  color: white;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: fade-in-out 3s ease-in-out forwards;
}

.toast-success {
  background-color: #4caf50;
}

.toast-error {
  background-color: #f44336;
}

.toast-warning {
  background-color: #ff9800; /* orange color */
}

@keyframes fade-in-out {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Toast/Toast.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,yCAAA;EACA,8CAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AACA;EACE,yBAAA,EAAA,iBAAA;AAEF;;AAEA;EACE;IAAK,UAAA;IAAY,2BAAA;EAGjB;EAFA;IAAM,UAAA;IAAY,wBAAA;EAMlB;EALA;IAAM,UAAA;IAAY,wBAAA;EASlB;EARA;IAAO,UAAA;IAAY,2BAAA;EAYnB;AACF","sourcesContent":[".toast {\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  padding: 12px 20px;\r\n  border-radius: 8px;\r\n  color: white;\r\n  font-weight: bold;\r\n  z-index: 9999;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n  animation: fade-in-out 3s ease-in-out forwards;\r\n}\r\n\r\n.toast-success {\r\n  background-color: #4caf50;\r\n}\r\n\r\n.toast-error {\r\n  background-color: #f44336;\r\n}\r\n.toast-warning {\r\n  background-color: #ff9800; /* orange color */\r\n}\r\n\r\n\r\n@keyframes fade-in-out {\r\n  0% { opacity: 0; transform: translateY(20px); }\r\n  10% { opacity: 1; transform: translateY(0); }\r\n  90% { opacity: 1; transform: translateY(0); }\r\n  100% { opacity: 0; transform: translateY(20px); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
